var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.onIE)?_c('div',[_c('p',[_vm._v("読み込み中...")])]):_c('Spinner',{attrs:{"name":_vm.type,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }